export default {
  paged: {
    select: 'id,fullName,isActive,email,roles,role,accessType,userId,extraData,isDefault',
    notSelectSearch: 'userId,extraData,user,twoFactorEnabled,roles,accessType,isDefault',
    expand: {
      position: { select: 'name' },
      area: { select: 'name' },
      user: { select: 'twoFactorEnabled' },
    },
    orderBy: 'fullName asc',
  },
  item: {
    select:
      'id,email,accessType,isActive,lastNames,mobilePhone,names,positionId,roles,role,updated,userBossId,extraData,areaId',
    expand: {
      position: { select: 'id,name' },
      area: { select: 'id,name' },
      userBoss: { select: 'id,fullName' },
      user: { select: 'twoFactorEnabled' },
    },
  },
  itemDetail: {
    select:
      'id,email,accessType,created,creator,isActive,lastNames,mobilePhone,names,roles,role,updated,modifier,extraData,userCreatorId,userModifierId',
    expand: {
      position: { select: 'name' },
      area: { select: 'name' },
      userBoss: { select: 'fullName' },
      user: { select: 'twoFactorEnabled,email' },
      userCreator: { select: 'id,fullName' },
      userModifier: { select: 'id,fullName' },
    },
  },
};
